import yup from "src/utils/yup/extensionMethods";

const invitesSchema = (translate: Function) => yup.object().shape({
	invites: yup.array().of(yup.object().shape({
		efa026Email: yup.string().email().required("Email é requerido"),
		efa026Efa004Id: yup.string().required(translate("Grupo de usuários é requerido"))
	}))
		.unique(translate("Email não podem ser repetidos"), (a: any) => a.efa026Email)
		.required(translate("É necessario preencher ao menos um convite"))
});

export const maintenanceSchema = (translate: Function) => yup.object().shape({
	eftba004: yup.array().of(yup.object().shape({
		efa004Id: yup.string().required(translate("Grupo de usuários é requerido"))
	}))
		.unique(translate("Grupo de usuários não podem ser repetidos"), (a: any) => a.efa004Id)
		.required(translate("É necessario preencher ao menos um grupo de usuários")),
	validateIP: yup.string().oneOf(["S", "N"]),
	eftba002: yup.array().of(yup.object().shape({
		efa002Id: yup.string().required(translate("Empresa é requerido"))
	}))
		.unique(translate("Empresas não podem ser repetidas"), (a: any) => a.efa002Id)
		.required(translate("É necessario preencher ao menos uma empresa"))
});

export const registerSchema = (translate: Function) => yup.object().shape({
	efa005Nome: yup.string().required(translate("Nome é necessario")),
	efa005Email: yup.string().email().required(translate("Email é obrigatório")),
	password: validatePassword(translate),
	efa005Tratamento: yup.string().nullable(),
	eftba004: yup.array().of(yup.number())
		.unique(translate("Grupo de usuários não podem ser repetidos"), (a: any) => a)
		.required(translate("É necessario preencher ao menos um grupo de usuários"))
		.min(1, translate("Ao menos um grupo deve ser informado")),
	eftba002: yup.array().of(yup.number())
		.unique(translate("Empresas não podem ser repetidas"), (a: any) => a)
		.required(translate("É necessario preencher ao menos uma empresa"))
		.min(1, translate("Ao menos uma empresa deve ser informada")),
	validateIP: yup.string().oneOf(["S", "N"]),
	daysExpirePassword: yup.string().nullable().max(5, translate("Dias para expirar a senha deve conter no máximo 5 caracteres"))
});

export const validatePassword = (translate: Function) => yup.string().min(8, translate("Senha deve ter no mínimo 8 dígitos")).matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/, translate("Deve conter 8 caracteres, um maiúsculo, um minúsculo, um número e um caractere especial"));

export default invitesSchema;
